'use client'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import React, { PropsWithChildren } from 'react'
import { Checkbox } from './checkbox'

export type CheckboxWithBorderProps = React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
  id: string
  label?: string
  labelProps?: {
    className?: string
  }
}

export const CheckboxWithBorder = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  PropsWithChildren<CheckboxWithBorderProps>
>(({ children, label, id, labelProps, ...props }, ref) => {
  return (
    <label
      htmlFor={id}
      className={`flex gap-2 items-center border border p-[10px] rounded-md ${labelProps?.className || ''}`}
    >
      <Checkbox id={id} ref={ref} {...props} />
      {children}
      {label}
    </label>
  )
})
CheckboxWithBorder.displayName = 'CheckboxWithBorder'
